import React from 'react'

const ExperiencePage = () => {
  return <div>slim shady</div>
}

export default ExperiencePage
